import { defineMessages } from 'react-intl';

export default defineMessages({
    dropdownNumberOfSearchResultsLabel: {
        id: 'cv.request.create.form.cmdbobjectpicker.numberofsearchresultslabel',
        defaultMessage: `{numberOfSearchResults, plural, one {# search result} other {# search results}}`,
        description:
            'Warning message informing user that the Insight field can only store a certain number of objects when they have exceeded the limit',
    },
});
